import ValidationResult from './ValidationResult';
import VALIDATION_ERRORS from './errors-validation';
import {
	NAME_MIN_LENGTH,
	NAME_MAX_LENGTH,
	PASSWORD_MIN_LENGTH
} from './constants-auth';
import {
	hasLowerCase,
	hasNumber,
	hasSpecialCharacter,
	hasUpperCase,
	isEmail
} from './stringHelpers';
// --- local imports ------

const nameRegex = /[^\s\d±!@£\?$%^&*_+§¡€#¢§¶•ªº«'"\\/{}()<>?:;|=\-.,]/;
export function validateName(name) {
	if (name.length < NAME_MIN_LENGTH) {
		return new ValidationResult(VALIDATION_ERRORS.NAMES.TOO_SHORT);
	}
	else if (name.length > NAME_MAX_LENGTH) {
		return new ValidationResult(VALIDATION_ERRORS.NAMES.TOO_LONG);
	}
	else if (!name.match(nameRegex)) {
		return new ValidationResult(VALIDATION_ERRORS.NAMES.MUST_CONTAIN_ALPHA);
	}

	return new ValidationResult();
}

export function validatePassword(password) {
	if (password.length < PASSWORD_MIN_LENGTH) {
		return new ValidationResult(VALIDATION_ERRORS.PASSWORDS.TOO_SHORT);
	}
	else if (!hasNumber(password)) {
		return new ValidationResult(VALIDATION_ERRORS.PASSWORDS.MUST_CONTAIN_NUMBER);
	}
	else if (!hasLowerCase(password)) {
		return new ValidationResult(VALIDATION_ERRORS.PASSWORDS.MUST_CONTAIN_LOWERCASE);
	}
	else if (!hasUpperCase(password)) {
		return new ValidationResult(VALIDATION_ERRORS.PASSWORDS.MUST_CONTAIN_UPPERCASE);
	}

	return new ValidationResult();
}

// Rules for a password the user is setting for the first time (registration, reset).
// Login uses validatePassword instead, so accounts created before the special
// character rule can still sign in with their existing password.
export function validateNewPassword(password) {
	const result = validatePassword(password);
	if (!result.isValid) {
		return result;
	}
	else if (!hasSpecialCharacter(password)) {
		return new ValidationResult(VALIDATION_ERRORS.PASSWORDS.MUST_CONTAIN_SPECIAL_CHARACTER);
	}

	return new ValidationResult();
}

export function validateConfirmPassword(password, passwordConfirm) {
	if (password !== passwordConfirm) {
		return new ValidationResult(VALIDATION_ERRORS.PASSWORDS.CONFIRM_NO_MATCH);
	}

	return new ValidationResult();
}

export function validateRequiredEmail(email) {
	if (email.length === 0) {
		return new ValidationResult(VALIDATION_ERRORS.EMAIL.REQUIRED);
	}
	else if (!isEmail(email)) {
		return new ValidationResult(VALIDATION_ERRORS.EMAIL.INVALID);
	}

	return new ValidationResult();
}

export function validateOptionalEmail(email) {
	if (email.length > 0 && !isEmail(email)) {
		return new ValidationResult(VALIDATION_ERRORS.EMAIL.OPTIONAL_INVALID);
	}

	return new ValidationResult();
}

export function validateEmail(email, isRequired = true) {
	if (isRequired) {
		return validateRequiredEmail(email);
	}
	else {
		return validateOptionalEmail(email);
	}
}

// Screens that render validation errors as plain text (not split into normal/bold
// runs) use this to flatten a { normal, bold } error into one string. Also accepts
// plain strings unchanged, since some screens set error state from hardcoded
// firebase-error messages rather than VALIDATION_ERRORS.
export function errorText(error) {
	if (!error || typeof error === 'string') {
		return error;
	}

	return `${error.normal}${error.bold}`;
}
